import React, { useEffect, useState } from 'react'
import { Button, Input, Modal, message, notification } from 'antd'
import axios from 'axios'
import { LockFilled } from '@ant-design/icons'

import './index.css'
import { get_v10_url } from '../../utils/commonUtilities'

const lockIcon = (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.89 4.82L6.25 3.16C6.61681 2.22836 7.25557 1.4287 8.08313 0.865101C8.91069 0.301501 9.88875 5.71153e-05 10.89 0C13.65 0 15.89 2.24 15.89 5V7H16.89C17.4204 7 17.9291 7.21071 18.3042 7.58579C18.6793 7.96086 18.89 8.46957 18.89 9V15.8L10.09 7H13.89V5C13.89 3.34 12.55 2 10.89 2C9.3 2 8 3.25 7.89 4.82ZM21 20.46L19.73 21.73L18.35 20.35C17.99 20.75 17.47 21 16.89 21H4.89C3.78 21 2.89 20.11 2.89 19V9C2.89 8.46957 3.10071 7.96086 3.47579 7.58579C3.85086 7.21071 4.35957 7 4.89 7H5L0 2L1.28 0.73L21 20.46ZM12.74 14.74L10.15 12.15C9.39 12.44 8.89 13.16 8.89 14C8.89 14.5304 9.10071 15.0391 9.47579 15.4142C9.85086 15.7893 10.3596 16 10.89 16C11.73 16 12.45 15.5 12.74 14.74Z" fill="#5E5D5D"/>
  </svg>
)

const ForgotPasswordModal = props => {
  const [stage, setStage] = useState(1)
  const [postData, setPostData] = useState('')
  const [email, setEmail] = useState('')
  const [otp, setOtp] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showPass, setShowPass] = useState(false)
  const [showConfirmPass, setShowConfirmPass] = useState(false)

  const sendResetCode = () => {
    if (postData === '') {
      notification.error({
        message: 'Error',
        description: 'Email cannot be empty'
      })
      return
    }
    if (postData !== '') {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(!emailRegex.test(postData)) {
        notification.error({
          message: 'Error',
          description: 'Please enter valid email'
        })
        return
      }
    }
    axios
      .post(`${get_v10_url()}/professional/requestOTP`, { email: email })
      .then(res => {
        if (res.data?.success) {
          notification.success({
            message: 'Success',
            description: 'OTP Generated Successfully'
          })
          setStage(2)
          setPostData('')
        } else {
          notification.error({
            message: 'Error',
            description: res.data?.msg || 'Something went wrong'
          })
        }
      })
      .catch(err => {
        notification.error({
          message: 'Error',
          description: err.response?.data?.msg || 'Please try again'
        })
      })
  }

  const verifyEmail = () => {
    if (postData === '') {
      notification.error({
        message: 'Error',
        description: 'OTP cannot be empty'
      })
      return
    }
    axios
      .post(`${get_v10_url()}/professional/verifyOTP`, {
        email: email,
        otp: postData
      })
      .then(res => {
        if (res.data?.success) {
          notification.success({
            message: 'Success',
            description: 'OTP Verified'
          })
          setStage(3)
          setPostData('')
        } else {
          notification.error({
            message: 'Error',
            description: 'OTP Incorrect'
          })
        }
      })
      .catch(err => {
        console.error(err)
        notification.error({
          message: 'Error',
          description: err.response?.data?.msg || 'Please try again'
        })
      })
  }

  const resetForgotPassword = () => {
    if (postData === '') {
      notification.error({
        message: 'Error',
        description: 'Password cannot be empty'
      })
      return
    }
    if (postData !== confirmPassword) {
      notification.error({
        message: 'Error',
        description: "Passwords don't match"
      })
      return
    }
    if (postData.length < 8) {
      notification.error({
        message: 'Error',
        description: "Passwords must contains at least 8 characters"
      })
      return
    }
    axios
      .post(`${get_v10_url()}/professional/resetForgotPassword`, {
        email: email,
        otp: otp,
        password: postData
      })
      .then(res => {
        if (res.data?.success) {
          // console.log(res.data)
          notification.success({
            message: 'Success',
            description: 'Password reset successfully'
          })
          setPostData('')
          setConfirmPassword('')
          setOtp('')
          setEmail('')
          setStage(1)
          props.close()
        } else {
          notification.error({
            message: 'Error',
            description: res.data?.msg
          })
        }
      })
      .catch(err => {
        console.error(err)
        notification.error({
          message: 'Error',
          description: 'Please try again'
        })
      })
  }

  const handleSubmit = () => {
    if (stage === 1) sendResetCode()
    else if (stage === 2) verifyEmail()
    else if (stage === 3) resetForgotPassword()
  }

  useEffect(() => {
    if (stage === 1) setEmail(postData)
    else if (stage === 2) setOtp(postData)
  }, [postData, stage])

  return (
    <Modal
      onCancel={props.close}
      visible={props.isOpen}
      className='forgot-password-modal'
    >
      <div
        style={{
          width: '60%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img
          src={`/icons/${
            stage === 1
              ? 'forgot_password'
              : stage === 2
              ? 'verify_email'
              : 'reset_password'
          }.svg`}
          style={{ width: '100%' }}
        />
      </div>
      <div
        style={{
          width: '40%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          padding: '0px 20px 0px 40px'
        }}
      >
        <h1 style={{ fontWeight: 'bold' }}>
          {stage === 1
            ? 'Forgot Password?'
            : stage === 2
            ? 'Verify Your Email'
            : 'Create New Password'}
        </h1>
        <h3 style={{ marginBottom: '50px', fontWeight: 'bold' }}>
          {stage === 1
            ? 'Please enter your email address to receive a reset code'
            : stage === 2
            ? `Please enter the 4 digit code sent to ${email}`
            : ''}
        </h3>
        <label>
          {stage === 1 ? 'Email Address' : stage === 2 ? 'OTP' : 'Password'}
        </label>
        <Input
          value={postData}
          onChange={e => setPostData(e.target.value)}
          type={`${stage === 3 ? (showPass ? 'text' : 'password') : 'text'}`}
          style={{
            marginTop: '5px',
            marginBottom: '20px',
            height: '50px',
            border: '1px solid #00A82E',
            borderRadius: '10px'
          }}
          suffix={stage===3 ? <div onClick={()=>setShowPass(!showPass)} style={{cursor:'pointer', marginTop:'5px'}}>{showPass ? <LockFilled style={{color:'#5E5D5D', fontSize:'20px'}}/> : lockIcon}</div> : <></>}
        />
        {stage === 3 && (
          <>
            <label>Confirm Password</label>
            <Input
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              type={showConfirmPass ? 'text' : 'password'}
              style={{
                marginTop: '5px',
                marginBottom: '20px',
                height: '50px',
                border: '1px solid #00A82E',
                borderRadius: '10px'
              }}
              suffix={<div onClick={()=>setShowConfirmPass(!showConfirmPass)} style={{cursor:'pointer', marginTop:'5px'}}>{showConfirmPass ? <LockFilled style={{color:'#5E5D5D', fontSize:'20px'}}/> : lockIcon}</div>}
            />
          </>
        )}
        <Button
          onClick={handleSubmit}
          style={{
            width: '100%',
            background: '#00A82E',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '10px',
            height: '40px'
          }}
        >
          {stage === 1
            ? 'Send Reset Code'
            : stage === 2
            ? 'Verify Code'
            : 'Submit'}
        </Button>
      </div>
    </Modal>
  )
}

export default ForgotPasswordModal
